export { default } from "./ComparisonShoppingModal";
